import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { CompanyCalendarRoute } from './company-calendar.route';
import { EntityDataService } from '@ngrx/data';
import { CompanyCalendarDataService } from '../data-services/company-calendar/company-calendar.data-service';
import { entityName } from '../data-services/company-calendar/company-calendar.data-service';
import { CompanyCalendarFeatureComponent } from './company-calendar-feature/company-calendar-feature.component';
import { CompanyCalendarPresenterComponent } from './company-calendar-presenter/company-calendar-presenter.component';
import { FullCalendarModule } from '../shared/components/fullcalendar/fullcalendar.module';

@NgModule({
    declarations: [
        CompanyCalendarFeatureComponent,
        CompanyCalendarPresenterComponent
    ],
    providers: [CompanyCalendarDataService],
    imports: [
        CommonModule,
        SharedModule,
        FullCalendarModule,
        UIRouterModule.forChild({
            states: [CompanyCalendarRoute]
        })
    ]
})
export class CompanyCalendarModule {
    constructor(
        entityDataService: EntityDataService,
        companyCalendarDataService: CompanyCalendarDataService
    ) {
        entityDataService.registerService(
            entityName,
            companyCalendarDataService
        );
    }
}
